import { apiRequest } from "./apiClient";

export function loginAdmin(credentials) {
  return apiRequest("/auth/login", {
    method: "POST",
    body: credentials,
  });
}

export function fetchAdminOverview() {
  return apiRequest("/admin/overview");
}

export function fetchAdminJobs() {
  return apiRequest("/admin/jobs");
}

export function fetchCalendarEvents() {
  return apiRequest("/admin/calendar/events");
}

export function fetchAdminPriceItems() {
  return apiRequest("/admin/pricing");
}

export function saveAdminPriceItem(item) {
  return apiRequest("/admin/pricing", {
    method: item.id ? "PUT" : "POST",
    body: item,
  });
}

export function deleteAdminPriceItem(id) {
  return apiRequest("/admin/pricing", {
    method: "DELETE",
    body: { id },
  });
}

export function startGoogleCalendarConnect() {
  return apiRequest("/admin/google-calendar/connect", {
    method: "POST",
  });
}
